import { injectable, inject } from "inversify";
import { ActivitySummary } from "@project/domain/models/activity-summary.model";
import { ActivityRepository } from "@beneficiary/data/repositories/activity.repository";

@injectable()
export class GetActivitiesByIdsUseCase {
    constructor(
        @inject(ActivityRepository)
        private readonly activityRepository: ActivityRepository,
    ) { }

    /**
     * Obtiene la información completa de múltiples actividades a partir de sus IDs
     * @param ids Array de IDs de actividades
     * @returns Promise con el array de Activities
     */
    async execute(ids: number[]): Promise<ActivitySummary[]> {
        if (!ids.length) {
            return [];
        }

        try {
            const activities = await this.activityRepository.getByIds(ids);
            return activities;
        } catch (error) {
            console.error("Error al obtener actividades por IDs:", error);
            return [];
        }
    }
}